import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useRecoilValue } from 'recoil';

import { deleteKiosk } from 'api/Kiosk';

import { useCustomMutation } from 'lib/hooks/useCustomMutation';

import { currentPractice } from 'components/practice/practiceState';
import Confirm from 'components/shared/Modal/Confirm/Confirm';
import Popover from 'components/shared/Popovers/Popover/Popover';

import EditKioskModal from '../lib/Edit/EditKioskModal';

const Actions = ({ data }) => {
  const [deleteKioskModal, setDeleteKioskModal] = useState(null);
  const [editKiosk, setEditKiosk] = useState(null);
  const navigate = useNavigate();
  const practiceId = useRecoilValue(currentPractice);

  const actionOptions = [
    {
      label: 'Edit',
      icon: 'edit-2-mono',
      onClick: () => setEditKiosk(data),
      permission: {
        requiredPermissions: 'kiosk.update'
      }
    },
    {
      label: 'Delete',
      icon: 'trash-mono',
      onClick: () => setDeleteKioskModal(data.id),
      permission: {
        requiredPermissions: 'kiosk.delete'
      }
    }
  ];

  const { mutate: deleteKioskHandler } = useCustomMutation({
    mutationFn: () => deleteKiosk(navigate, { practiceId, id: deleteKioskModal }),
    successMessage: 'Successfully deleted kiosk!',
    invalidateQueryKey: 'kiosks',
    onSuccess: () => {
      setDeleteKioskModal(null);
    }
  });

  return (
    <>
      <Popover
        className="flex h-full w-full items-center justify-center"
        position="left"
        isFixed
        icon="context-menu-horizontal"
        options={actionOptions}
        isBorder={false}
      />
      {!!deleteKioskModal && (
        <Confirm
          variant="danger"
          primaryBtnTxt="Delete"
          title="Delete Kiosk"
          message="Are you sure you want to delete Kiosk?"
          handleContinue={deleteKioskHandler}
          handleOpen={!!deleteKioskModal}
          handleClose={() => setDeleteKioskModal(null)}
        />
      )}
      {editKiosk && <EditKioskModal kiosk={data} setKiosk={setEditKiosk} />}
    </>
  );
};

export default Actions;
